// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1132":"7826dbf5","4315":"7826dbf5","8337":"7826dbf5","9085":"7826dbf5"}[chunkId] + ".chunk.css";
};